import { EventTypeInput } from '../../types/ViewModel/EventTypeInput';
// Import JSON configuration (Vite/TS handles JSON modules)
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import overrides from '../../config/eventInputHeadingOverrides.json';

interface EventInputHeadingOverride {
    eventTypeId: number;
    dropdownGroupId?: number;
    inputHeadingOverride: string;
}

const overrideList = overrides as EventInputHeadingOverride[];

export const getOverriddenHeading = (eventTypeInput: EventTypeInput): string | null => {
    if (!eventTypeInput) return null;
    const eventTypeId = eventTypeInput.eventTypeId;
    const dropdownGroupId = eventTypeInput.dropdownGroup?.dropdownGroupId;

    if (dropdownGroupId !== undefined) {
        const strict = overrideList.find(
            (o) => o.eventTypeId === eventTypeId && o.dropdownGroupId !== undefined && o.dropdownGroupId === dropdownGroupId
        );
        if (strict) return strict.inputHeadingOverride;
    }

    const generic = overrideList.find((o) => o.eventTypeId === eventTypeId && o.dropdownGroupId === undefined);
    if (generic) return generic.inputHeadingOverride;

    return null;
};

export const resolveHeading = (eventTypeInput: EventTypeInput): string => {
    return getOverriddenHeading(eventTypeInput) ?? eventTypeInput.inputHeading;
};

export type { EventInputHeadingOverride };
